export default {
  register: {
    title: 'سائن اپ',
    username: 'صارف کا نام',
    phone: 'فون نمبر',
    phoneCode: 'کوڈ',
    email: 'ای میل',
    password: 'پاس ورڈ',
    captcha: 'کیپچا',
    smsCode: 'SMS کوڈ',
    emailCode: 'ای میل کوڈ',
    verificationCode: 'ای میل کوڈ',
    invitationCode: 'دعوت نامہ کوڈ',
    loading: 'لوڈ ہو رہا ہے...',
    send: 'بھیجیں',
    sendCode: 'کوڈ بھیجیں',
    signUp: 'سائن اپ',
    contactUs: 'ہم سے رابطہ کریں？',
    haveAccount: 'پہلے سے اکاؤنٹ ہے؟',
    signIn: 'سائن ان',
    loginNow: 'سائن ان کریں',
    or: 'یا',
    orSignUpWith: 'یا اس کے ساتھ سائن اپ کریں',
    methodUsername: 'صارف نام',
    methodPhone: 'فون',
    methodEmail: 'ای میل',
    codeOptional: 'کوڈ (اختیاری)',
    privacyPolicy: 'میں تصدیق کرتا ہوں کہ میری عمر 18 سال سے زیادہ ہے اور میں قبول کرتا ہوں',
    privacyPolicyLink: 'رازداری کی پالیسی',
    and: 'اور',
    termsConditions: 'شرائط و ضوابط',
    vault: 'تجوری',
    receivePromos: 'ای میل پروموز وصول کریں',
    usernameRequired: 'صارف کا نام ضروری ہے',
    usernameInvalid: 'صارف کا نام صرف حروف، نمبر اور انڈر سکور پر مشتمل ہو سکتا ہے',
    phoneRequired: 'فون نمبر ضروری ہے',
    phoneInvalid: 'فون نمبر کی شکل غلط ہے',
    emailRequired: 'ای میل ضروری ہے',
    emailInvalid: 'ای میل کی شکل غلط ہے',
    passwordRequired: 'پاس ورڈ ضروری ہے',
    passwordInvalid: 'پاس ورڈ تقاضوں کو پورا نہیں کرتا',
    captchaRequired: 'کیپچا ضروری ہے',
    smsCodeRequired: 'SMS کوڈ ضروری ہے',
    emailCodeRequired: 'ای میل کوڈ ضروری ہے',
    privacyPolicyRequired: 'براہ کرم رازداری کی پالیسی اور شرائط و ضوابط قبول کریں',
    passwordHintLow: 'کم از کم 6 ہندسے',
    passwordHintMedium: 'کم از کم 6 حروف حروف اور نمبروں کے ساتھ',
    passwordHintHigh: 'کم از کم 6 حروف حروف، نمبروں اور علامتوں کے ساتھ',
    // Format validation
    usernameFormat: 'صرف حروف، نمبر اور _',
    emailFormat: 'ای میل کی شکل غلط ہے',
    // Toast messages
    smsCodeSent: 'SMS کوڈ بھیج دیا گیا',
    emailCodeSent: 'ای میل کوڈ بھیج دیا گیا',
    smsCodeFailed: 'SMS کوڈ بھیجنے میں ناکامی',
    emailCodeFailed: 'ای میل کوڈ بھیجنے میں ناکامی',
    registerSuccess: 'رجسٹریشن کامیاب',
    registerFailed: 'رجسٹریشن ناکام',
    // Google sign in
    signInWithGoogle: 'Google+ کے ساتھ سائن ان کریں'
  }
};
